<template>
  <Layout>
    <div class=" bg-light" id="receipt" >
       <!-- Print company -->
        <div class="print-company d-print-block d-none">
          <div class="company-content">
            <img :src="require('@/assets/images/logo.png')" alt="Logo" class="logo" />
            <h1>APS PACKAGING<sup>®</sup></h1>
          </div>
        </div>
      <div class="container pt-5">
        <div class="row justify-content-center">
          <div class="col-md-10" >
            <div class="card shadow">
              <div class="card-body"  v-if="this.order && !this.isOrderLoading">
                <!-- Success animation -->
                <div class="text-center mb-4">
                  <div class="success-animation mb-1 mt-1 ">
                    <img
                      :src="require('@/assets/icons/check-circle-colored.svg')"
                      width="70" height="70" alt="Success" />

                  </div>
                  
                  <h1 class=" font-weight-bold mb-2" style="color: #01219a">{{ order && order.paymentMethod == 0 ? 'Commande prise en compte' :  'Paiement Réussi' }} </h1>

                  <div v-if="order && order.paymentMethod == 0" class="card text-dark bg-light p-2 m-md-4  font-size-14 " >
                    <div>Votre commande est prise en compte, notre service commercial prendra contact avec vous dans un delais de  24&nbsp;heures pour validation.</div>
                    <div>Merci de rester joignable pour confirmer votre commande.</div>
                  </div>

                  <p v-else class="lead  text-dark  ">Merci pour votre achat. Votre commande a été traitée avec succès.</p>

                  <div class="divider my-4 d-print-block"></div>
                </div>
                
                <!-- Order Summary Section -->
                  <div class="row  m-md-4 m-0 align-items-stretch d-flex ">
                    <div class="col-md-6 d-flex mb-4 mb-md-0 pr-md-2" >
                      <div class="card order-summary bg-light text-dark  p-3 w-100">
                        <h2 class="h4 mb-3 text-dark font-weight-bold">Détails de la Commande</h2>

                          <div class="d-flex justify-content-between mb-2">
                            <span>COMMANDE N°:</span>
                            <span>{{ order.ref }}</span>
                          </div>
                          
                          <div class="d-flex justify-content-between mb-2">
                            <span>Date:</span>
                            <span>{{ order.date }} </span>
                          </div>

                          <div class="d-flex justify-content-between mb-2">
                            <span>Référent commercial:</span>
                            <span>{{ order.salesRepresentative }} </span>
                          </div>
                          <div v-if="order.paymentMethod == 1" class="d-flex justify-content-between mb-2">
                            <span>Paiement:</span>
                            <span>Carte Bancaire</span>
                          </div>

                      </div>
                    </div>
                    <div class="col-md-6 pl-md-2 d-flex">
                        <div class="card order-summary bg-light text-dark  p-3 w-100">
                          <h2 class="h4 mb-3 text-dark font-weight-bold">Récapitulatif de la commande</h2>

                          <!-- Order lines -->
                          <div class="">
                              <div v-for="(item) in order.lines" :key="item.id" class="d-flex justify-content-between mb-2">
                                  <div class="text-left">
                                      <h6 class="my-0  text-dark">{{ item.quantity &&  item.quantity != 1 ? item.quantity + ' x ': ''  }}{{item.itemTitle}} </h6>
                                      <small v-if="item.quantity &&  item.quantity != 1" class="text-muted font-size-14">{{ item.itemVariantTitle}}</small>
                                      <div  v-if="item.quantity &&  item.quantity != 1"><span class="badge badge-light font-weight-bold">{{ item.paperTypeLabel }}</span></div>
                                      <div  v-if="item.quantity &&  item.quantity != 1"><span class="badge badge-light font-weight-bold">{{ item.paperColorLabel }}</span></div>
                                  </div>
                                  <span class=" text-dark">{{item.lineTotalAmount }}</span>
                              </div>
                          </div>
                          <!-- delivery Cost (conditionally rendered) -->
                          <div  v-if="order.deliveryCost && order.deliveryCostFloat && order.deliveryCostFloat !== 0" class="d-flex justify-content-between mt-3">
                            <div>
                              <h6 class="my-0  text-dark">Frais de Livraison</h6>
                            </div>
                            <span >{{ order.deliveryCost && order.deliveryCost !== '' ? ' + ' + order.deliveryCost : '' }}</span>
                          </div>
                          <hr>
                          <!-- Total -->
                          <div class="d-flex justify-content-between mb-3 text-dark">
                              <span>Total</span>
                              <span>{{  order.total }}</span>
                          </div> 
                          <!-- Discount (conditionally rendered) -->
                          <div  v-if="order.giftCardAmount" class="d-flex justify-content-between mt-3">
                            <div>
                              <h6 class="my-0  text-dark">Code PROMO</h6>
                            </div>
                            <span >{{ order.giftCardAmount ? ' - ' + order.giftCardAmount : '' }}</span>
                          </div>
                          <hr v-if="order.finalAmountToPay">
                          <div v-if="order.finalAmountToPay"  class="d-flex justify-content-between mb-3 text-dark">
                            <span class="fw-semibold">Net à payer</span>
                            <strong>{{ order.finalAmountToPay }}</strong>
                        </div>
                        </div>  
                    </div>
                  </div>
             
                <div class="divider my-4 d-print-block"></div>
                
                <!-- Client Details Section -->
                <div class="client-details card bg-light m-md-4 m-0 p-3 no-break">
                  <h2 class="h4 mb-3 text-dark font-weight-bold">Client : {{  order.customerName }}</h2>
                  <div class="row">
                    <div class="col-12 pr-md-2 pl-2 text-dark">
                      
                        <div class="info-item">
                          <img class="mt-1  mr-2" :src="require('@/assets/icons/telephone-filled.svg')"
                          width="20" height="20" alt="Success" />
                          <span class="mt-2">{{ order.customerPhone }}</span>
                        </div>
                        <div class="info-item">
                          <img class="mt-1  mr-2" :src="require('@/assets/icons/email-black.svg')"
                            width="20" height="20" alt="Success" />
                          <span class="mt-2">{{ order.customerMail }}</span>
                        </div>
                        <div v-if="order && order.companyName" class="info-item">
                          <img class=" mr-2" :src="require('@/assets/icons/company.svg')"
                            width="20" height="20" alt="Success" />
                          <span class="mt-2">{{ order.companyName }} {{ order.businessName ? "("+ order.businessName +")" : ''  }}</span>
                        </div>
                        <div v-if="order && order.taxRefNumber" class="info-item">
                          <img class=" mr-2" :src="require('@/assets/icons/save.svg')"
                            width="20" height="20" alt="Success" />
                          <span class="mt-2">Matricule fiscale: {{ order.taxRefNumber }}</span>
                        </div>
                        <div class="info-item">
                          <img class=" mr-2" :src="require('@/assets/icons/position.svg')"
                            width="20" height="20" alt="Success" />
                          <span class="mt-2">{{order.customerFullAddress}} </span>
                        </div>
                        <div class="info-item">
                          <img class="mt-1 mr-2" :src="require('@/assets/icons/delivery-fast.svg')"
                            width="22" height="22" alt="Success" />
                          <span class="mt-2">{{order.deliveryMode.name}}{{ order.deliveryMode.costAsFloat !== 0.0 ? '. La livraison est estimée dans un délai de 48 heures.' : '' }}</span>
                        </div>

                        <div class="info-item">
                          <img v-if="order.paymentMethod == 0 " class="mt-1 mr-2" :src="require('@/assets/icons/cash.svg')"
                            width="22" height="22" alt="Success" />
                          <img v-else class="mt-1 mr-2" :src="require('@/assets/icons/bank-card.svg')"
                            width="22" height="22" alt="Success" />
                          <span class="mt-2">{{order.paymentMethod == 0 ? 'Paiement à la livraison' : 'Paiement en ligne' }}</span>
                        </div>

                    </div>
                  </div>
                </div>
                
                <div class="divider my-4 d-print-block"></div>
                
                <!-- Message Section -->
                <div class="message-section card bg-light m-md-4 m-0 p-3 no-break">
                  <h2 class="h4 mb-3 text-dark font-weight-bold">Messages</h2>
                  <div class="row">
                    <div class="col-md-6 mb-3 pr-md-2">
                      <div class="message-card">
                        <div class="p-2" style="background-color: #01219a">
                          <h5 class="text-message-card mb-0">Message du Graphiste</h5>
                        </div>
                        <div class="p-2 p-md-3">
                          <p class="mb-0 text-dark">{{ order.message  ? order.message : '_'}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3 pl-md-2 pt-2 pt-md-0">
                      <div class="message-card">
                        <div class="p-2" style="background-color: #01219a">
                          <h5 class="text-message-card mb-0">Suggestions</h5>
                        </div>
                        <div class="p-2 p-md-3">
                          <p class="mb-0 text-dark">{{ order.feedback  ? order.feedback : '_'}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="divider my-4 d-print-none"></div>
                
                <!-- Action Buttons -->
                <div class="action-buttons m-md-4 m-3">
                  <div class="row">
                    <div class="col-md-4 mb-3">
                      <a href="/sac-personnalise">
                        <button  class="btn btn-primary btn-block btn-lg">
                          <img class=" mr-2" :src="require('@/assets/icons/cart-4.svg')"
                            width="30" height="30" alt="Success" />
                          <span class="mt-2">Continuer les Achats</span>
                        </button>
                      </a>
                    </div>
                    <div class="col-md-4 mb-3"/>
                    <div class="col-md-4 mb-3 ">
                      <button @click="printReceipt" class="btn btn-secondary btn-block btn-lg">
                        <img class=" mr-2" :src="require('@/assets/icons/print-filled-white.svg')"
                          width="30" height="30" alt="Success" />
                        <span class="mt-2">Imprimer</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
  
<script>
  import Layout from "../../layouts/main.vue";
  import OrdersApi from "@/services/orders-api";

  export default {
    name: 'SuccessPaiement',
    components: { Layout },
    props: {
      order_s_ref:String,
      orderId:String
    },
    data() {
      return {
        isOrderLoading :false ,
        order:null,
        orderDetails: {
          orderId: 'CMD-12345',
          paymentMethod: 'Carte Bancaire',
          date: new Date().toLocaleDateString(),
          amount: '1250.00'
        },
        clientDetails: {
          telephone: '+216 71 234 567',
          email: 'client@example.com',
          deliveryAddress: {
            address: '123 Rue Principale',
            city: 'Tunis',
            postalCode: '1002'
          },
          companyName: 'Société Exemplaire',
          fiscalId: 'TUN12345678'
        },
        messages: {
          graphiste: 'Votre conception graphique est prête à être imprimée. Merci pour votre commande!',
          suggestions: 'Pour une meilleure qualité, nous vous suggérons d\'utiliser un papier premium pour vos cartes de visite.'
        }
      }
    },
    mounted(){
      this.getOrderByPaymentRef()
      this.getOrderBySpecialRef()
    },
    methods: {
      getOrderByPaymentRef(){
        if(this.orderId == 'undefined' || !this.orderId){
          return null
        }
        this.isOrderLoading = true ,
        OrdersApi.getOrderByPaymentRef(this.orderId)
        .then(order => {
          if(order){
            this.order = order;
            this.$store.commit('setGiftCode', this.order.giftCode);
          }
        })
        .finally(() => {
          this.isOrderLoading = false 
        })
      },
      getOrderBySpecialRef() {
        if(this.order_s_ref == 'undefined' || !this.order_s_ref){
          return null
        }
        this.isOrderLoading = true ,
        OrdersApi.getOrderBySpecialRef(this.order_s_ref)
        .then(order => {
          this.order = order;
          this.$store.commit('setGiftCode', this.order.giftCode);
        })
        .finally(() => {
          this.isOrderLoading = false 
        })
      },
      printReceipt() {
        window.print();
      }
    }
  }
</script>
  
<style scoped>
 
  .card {
    border-radius: 10px;
    border: none;
  }
  
  .success-animation {
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .success-animation img {
    animation: pulse 1.5s infinite;
  }

  @keyframes pulse {
    0%   { transform: scale(1); opacity: 1; }
    50%  { transform: scale(1.1); opacity: 0.7; }
    100% { transform: scale(1); opacity: 1; }
  }
  
  .divider {
    height: 1px;
    background-color: #e9ecef;
    position: relative;
  }
  
  .details-section {
    border-radius: 8px;
  }
  
  .payment-badge {
    padding: 15px;
    border-radius: 8px;
    background-color: #89a0f52b;
    width: 100%;
    max-width: 300px;
  }

  .info-item {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }

  .message-card {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    height: 100%;
  }
  .text-message-card{
    color: white;
  }
  
  .card-body {
    padding: 15px;
    border-radius: 20px;
    background-color: white;
  }
  
  .btn {
    padding: 12px 15px;
    font-weight: 500;
    border-radius: 6px;
    transition: all 0.3s ease;
  }
  
  .btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  @media print {
    
    @page {
      margin: 5mm;
    }
    .action-buttons {
      margin: 0;
      display: none;
    }
    .text-message-card{
      color: black;
    }
    .print-company {
      margin: 20px;
      z-index: 999999;
      width: 50%;
      text-align: left;
      background: white;
    }

    .print-company .logo {
      height: 40px;
      vertical-align: middle;
      margin-right: 10px;
    }

    .print-company h1 {
      display: inline-block;
      font-size: 18px;
      vertical-align: bottom;
      margin: 0;
    }
    .badge{
      border: 0px;
    }
 
    #receipt, #receipt * {
      visibility: visible; 
    }

    #receipt {
      border: 2px solid black;
    }
    .no-break {
      page-break-inside: avoid;
    }
}

</style>